
/** auth */
export const FETCH_AUTH_RESOURCE_REQUEST = 'FETCH_AUTH_RESOURCE_REQUEST'
export const FETCH_AUTH_RESOURCE_SUCCESS = 'FETCH_AUTH_RESOURCE_SUCCESS'
export const FETCH_AUTH_RESOURCE_FAILED = 'FETCH_AUTH_RESOURCE_FAILED'
export const CREATE_MEMBER_AUTH_REQUEST = 'CREATE_MEMBER_AUTH_REQUEST'
export const CREATE_MEMBER_AUTH_SUCCESS = 'CREATE_MEMBER_AUTH_SUCCESS'
export const CREATE_MEMBER_AUTH_FAILED = 'CREATE_MEMBER_AUTH_FAILED'
export const CREATE_MEMBER_AUTH_OTP_REQUEST = 'CREATE_MEMBER_AUTH_OTP_REQUEST'
export const CREATE_MEMBER_AUTH_OTP_SUCCESS = 'CREATE_MEMBER_AUTH_OTP_SUCCESS'
export const CREATE_MEMBER_AUTH_OTP_FAILED = 'CREATE_MEMBER_AUTH_OTP_FAILED'
export const DELETE_MEMBER_AUTH_REQUEST = 'DELETE_MEMBER_AUTH_REQUEST'
export const DELETE_MEMBER_AUTH_SUCCESS = 'DELETE_MEMBER_AUTH_SUCCESS'
export const DELETE_MEMBER_AUTH_FAILED = 'DELETE_MEMBER_AUTH_FAILED'
export const SAVE_REQUIRED_SERVICE = 'SAVE_REQUIRED_SERVICE'
export const CHANGE_PROJECT = 'CHANGE_PROJECT'
/** profile */
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED'
export const CREATE_PRIVACY_DOCUMENT_REQUEST = 'CREATE_PRIVACY_DOCUMENT_REQUEST'
export const CREATE_PRIVACY_DOCUMENT_SUCCESS = 'CREATE_PRIVACY_DOCUMENT_SUCCESS'
export const CREATE_PRIVACY_DOCUMENT_FAILED = 'CREATE_PRIVACY_DOCUMENT_FAILED'

/** only mutaion */
export const UPDATE_GROUP_OPTIONS = 'UPDATE_GROUP_OPTIONS'

/** common */
export const FETCH_SELECTED_PROJECT = 'FETCH_SELECTED_PROJECT'
export const FETCH_SELECTED_MONTH = 'FETCH_SELECTED_MONTH'
export const FETCH_SELECTED_MONTH_RANGE = 'FETCH_SELECTED_MONTH_RANGE'
export const FETCH_SELECTED_GROUP = 'FETCH_SELECTED_GROUP'
export const FETCH_MONTHS_REQUEST = 'FETCH_MONTHS_REQUEST'
export const FETCH_MONTHS_SUCCESS = 'FETCH_MONTHS_SUCCESS'
export const FETCH_MONTHS_FAILED = 'FETCH_MONTHS_FAILED'

/** Board */
export const FETCH_BOARD_DOCUMENTS_REQUEST = 'FETCH_BOARD_DOCUMENTS_REQUEST'
export const FETCH_BOARD_DOCUMENTS_SUCCESS = 'FETCH_BOARD_DOCUMENTS_SUCCESS'
export const FETCH_BOARD_DOCUMENTS_FAILED = 'FETCH_BOARD_DOCUMENTS_FAILED'
export const FETCH_BOARD_DOCUMENT_REQUEST = 'FETCH_BOARD_DOCUMENT_REQUEST'
export const FETCH_BOARD_DOCUMENT_SUCCESS = 'FETCH_BOARD_DOCUMENT_SUCCESS'
export const FETCH_BOARD_DOCUMENT_FAILED = 'FETCH_BOARD_DOCUMENT_FAILED'

/** Megazone Pops */
export const CREATE_MEGAZONE_POPS_AUTH_REQUEST = 'CREATE_MEGAZONE_POPS_AUTH_REQUEST'
export const CREATE_MEGAZONE_POPS_AUTH_SUCCESS = 'CREATE_MEGAZONE_POPS_AUTH_SUCCESS'
export const CREATE_MEGAZONE_POPS_AUTH_FAILED = 'CREATE_MEGAZONE_POPS_AUTH_FAILED'

/** agreement when first `Megazone Pops` login */
export const FETCH_PRIVACY_DOCUMENT_REQUEST = 'FETCH_PRIVACY_DOCUMENT_REQUEST'
export const FETCH_PRIVACY_DOCUMENT_SUCCESS = 'FETCH_PRIVACY_DOCUMENT_SUCCESS'
export const FETCH_PRIVACY_DOCUMENT_FAILED = 'FETCH_PRIVACY_DOCUMENT_FAILED'
export const FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST = 'FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST'
export const FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS = 'FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS'
export const FETCH_PRIVACY_DOCUMENT_VERSIONS = 'FETCH_PRIVACY_DOCUMENT_VERSIONS'

/** region */
export const FETCH_REGION_REQUEST = 'FETCH_REGION_REQUEST'
export const FETCH_REGION_SUCCESS = 'FETCH_REGION_SUCCESS'
export const FETCH_REGION_FAILED = 'FETCH_REGION_FAILED'

/** Tags */
export const FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST'
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS'
export const FETCH_TAGS_FAILED = 'FETCH_TAGS_FAILED'
